import React from 'react';
import { Pause, Play, SkipBack, SkipForward, Volume2, Music2 } from 'lucide-react';
import { formatTime } from '../api';

export default function PlayerBar({ player }) {
  const { currentSong, currentSongIndex, isPlaying, volume, progress, duration, audioRef, playSong, nextSong, prevSong, handleSeek, setVolume } = player;

  return (
    <div className="player-bar">
      <div className="current-song-info">
        {currentSong ? (
          <>
            <div className="current-song-img"><Music2 size={24} /></div>
            <div className="song-details">
              <div>{currentSong.title}</div>
              <div>{currentSong.artist}</div>
            </div>
          </>
        ) : (
          <div style={{ color: 'var(--text-dim)', fontSize: '14px', marginLeft: '71px' }}>Ingen låt vald</div>
        )}
      </div>
      <div className="player-controls">
        <div className="control-buttons">
          <button className="ctrl-btn" onClick={prevSong} title="Föregående låt" aria-label="Föregående låt"><SkipBack size={19} /></button>
          <button className="ctrl-btn play-btn" onClick={() => currentSongIndex !== -1 && playSong(currentSongIndex)}>
            {isPlaying ? <Pause size={18} fill="currentColor" /> : <Play size={18} fill="currentColor" />}
          </button>
          <button className="ctrl-btn" onClick={nextSong} title="Nästa låt" aria-label="Nästa låt"><SkipForward size={19} /></button>
        </div>
        <div className="progress-container">
          <span className="time-label">{formatTime(audioRef.current.currentTime)}</span>
          <input type="range" min="0" max="100" value={progress} onChange={handleSeek} className="progress-slider" />
          <span className="time-label">{formatTime(duration)}</span>
        </div>
      </div>
      <div className="volume-container">
        <Volume2 size={19} />
        <input type="range" min="0" max="1" step="0.01" value={volume} onChange={e => setVolume(parseFloat(e.target.value))} className="volume-slider" />
      </div>
    </div>
  );
}
